import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const IntroductionPageStyle = styled('div')`
    ${typography.bodyMd}
    .text-signature {
        font-family: 'The Nautigal', cursive;
        font-size: 44.196px;
        font-weight: 400;
        line-height: 44.196px;
    }
    .color-success {
        color: var(--orange-300);
    }
    .text-line {
        text-decoration-line: underline;
    }

    .intro-title {
        ${typography.subhead}
        margin-bottom: 24px;
    }
    .box-line {
        margin-bottom: 24px;
        border-bottom: 1px solid var(--sand-400);
        padding-bottom: 48px;
    }
    .box-intro {
        border-radius: 6px;
        border: 1px solid var(--sand-400);
        background: var(--white);
        padding: 32px;
        color: var(--sand-700);
        margin-bottom: 36px;

        .m-bottom {
            margin-bottom: 20px;
        }

        .info-seller {
            display: flex;
            justify-content: space-between;
            align-items: end;
            text-align: right;
            font-weight: 900;
        }
    }

    .box-about {
        .consultant {
            text-align: right;
            font-weight: 900;
        }

        .detail {
            margin-bottom: 16px;
        }
    }

    &.is-safari {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 40px;

        > div,
        div:has(> .box-comment) {
            margin: 0;
        }

        .box-cart .item.savings {
            color: var(--sand-700);
            .value {
                font-weight: 600;
            }
        }

        ${media.mobile} {
            .box-intro {
                padding: 32px 16px;
            }

            .box-comment:not(.edit) {
                flex-direction: row;
                align-items: center;
                text-align: center;
                gap: 40px;

                .comment-value {
                    flex: 1;
                    width: auto;
                }

                .box-avatar {
                    width: auto;
                    margin-left: 0;
                    > * {
                        width: 89px;
                        height: 89px;
                    }
                }
            }
        }
    }

    .ready-book {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 54px 32px;
        border-radius: 6px;
        background: var(--sand-300);

        .title-ready {
            color: var(--sand-700);
            font-size: 24px;
            line-height: normal;
            letter-spacing: -0.02em;
            font-weight: 700;
        }

        .btn-pay {
            background-color: var(--orange-300);
            width: 100%;
            min-height: 48px;
            padding: 12px 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            color: var(--sand-100);
            text-align: center;
            ${typography.buttonLg}
            &:hover {
                background-color: var(--orange-400);
                color: var(--sand-100);
            }
        }

        ${media.mobile} {
            padding: 54px 16px;
            .btn-pay {
                font-size: 18px;
            }
        }
    }

    .box-cart {
        background-color: var(--white);
        border: 1px solid var(--sand-400);
        border-radius: 6px;
        padding: 24px 32px;
        position: relative;
        color: var(--sand-700);

        .title {
            font-size: 24px;
            line-height: normal;
            letter-spacing: -0.02em;
            font-weight: 700;
        }
        .sub-title {
            font-size: 20px;
            line-height: normal;
            letter-spacing: -0.03em;
            font-weight: 700;
            margin: 16px 0;
        }

        ${media.mobile} {
            padding: 24px 16px;
        }

        .group {
            display: none;
        }

        .box-total {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .item {
                padding: 0;
                &.total {
                    padding: 8px 0;
                }
            }
        }

        &.edit {
            border: 2px solid var(--orange-300);
            padding: 16px;
        }

        .iconAddComment {
            position: absolute;
            right: 0;
            top: 50%;
            margin-right: -25px;
            margin-top: -25px;
            cursor: pointer;
            transition: all 0.2s;
            z-index: 5;
            &:hover {
                transform: scale(1.1);
            }
        }
    }

    @media screen and (min-width: 992px) {
        .max-w {
            width: calc(100% - 100px);
        }
    }

    @media screen and (max-width: 767px) {
        .box-intro {
            .info-seller {
                flex-direction: column;
            }
        }
    }

    @media print {
        .box-intro,
        .box-line,
        .box-about {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-top: 24px;
        }
    }
`;
export default IntroductionPageStyle;
